import { ApiUrl } from '../app/Config';

define(['backbone'], function(Backbone) {
  return Backbone.Model.extend({
    urlRoot: ApiUrl + 'Users',
    idAttribute: 'Key',
  });
});
